import script from "./addGroupDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./addGroupDialog.vue?vue&type=script&lang=ts&setup=true"

import "./addGroupDialog.vue?vue&type=style&index=0&id=09fc3f3a&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09fc3f3a"]])

export default __exports__